import React, { useEffect, useRef, useState } from 'react'

import IntlTelInput from 'react-intl-tel-input'

import {
  formatPhoneNumber,
  formatPhoneNumberE164,
} from 'app/utils/phonenumber/helpers'

export const IntlTelInputWrapper = ({
  css,
  defaultCountry,
  preferredCountries,
  onPhoneNumberChange,
  onPhoneNumberBlur,
  value,
  placeholder,
  onlyCountries,
  onSelectFlag,
  fieldId,
  disabled,
}) => {
  const [phoneNumber, setPhoneNumber] = useState(value)
  const intlTelInputRef = useRef(null)

  useEffect(() => {
    if (formatPhoneNumberE164(value) !== formatPhoneNumberE164(phoneNumber)) {
      setPhoneNumber(formatPhoneNumber(value))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  const moveCursorToEnd = (input) => {
    if (input && document.activeElement === input) {
      input.setSelectionRange(input.value.length, input.value.length)
    }
  }

  const formatIntlTelNumber = (blur) => {
    return (status, value, countryData, number, id) => {
      setPhoneNumber(number)
      const formattedPhoneNumber = formatPhoneNumberE164(number)
      if (blur) {
        onPhoneNumberBlur(status, value, countryData, formattedPhoneNumber, id)
      } else {
        onPhoneNumberChange(
          status,
          value,
          countryData,
          formattedPhoneNumber,
          id,
        )

        // Only reposition cursor if formatting actually changed the display
        if (value !== number) {
          requestAnimationFrame(() => {
            const input = intlTelInputRef.current?.tel
            if (input) {
              moveCursorToEnd(input)
            }
          })
        }
      }
    }
  }

  return (
    <IntlTelInput
      ref={intlTelInputRef}
      css={css}
      defaultCountry={defaultCountry}
      preferredCountries={preferredCountries}
      onPhoneNumberChange={formatIntlTelNumber(false)}
      onPhoneNumberBlur={formatIntlTelNumber(true)}
      value={phoneNumber}
      placeholder={placeholder}
      onlyCountries={onlyCountries}
      onSelectFlag={onSelectFlag}
      fieldId={fieldId}
      disabled={disabled}
    />
  )
}
